"use strict";

define('view/product.navigation.menu',['require','exports','module','underscore','backbone','backbone.radio','uikit/uikit','templates'],function (require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Radio = require('backbone.radio');
  var UIKit = require('uikit/uikit');
  var Templates = require('templates');
  var MoreMenuItem = UIKit.Tree.TreeItem.extend({
    template: Templates.IRB['product.menu.tree.item'],
    options: _.extend(UIKit.Tree.TreeItem.prototype.options, {
      sectionDivider: false
    }),
    updateAttributes: function updateAttributes() {
      this.addClass('section-divider', this.getBoolOption('sectionDivider'));
      UIKit.Tree.TreeItem.prototype.updateAttributes.apply(this, arguments);
    },
    handleTitleKeydown: function handleTitleKeydown(ev) {
      this.root.triggerMethod('key:down', ev, this);
    },
    handleTitlePress: function handleTitlePress(ev) {
      if (this.model.get('header')) {
        ev.stopPropagation();
      } else {
        this.handleTriggerLeafPress();
      }
    },
    handleTriggerLeafPress: function handleTriggerLeafPress(ev) {
      if (this.model.get('header')) {
        ev.stopPropagation();
      } else {
        if (this.link) {
          this.ui.title.find('> a').get(0).click();
          this.root.close(0);
          return;
        }
        this.root.triggerMethod('leaf:press', this);
      }
    }
  });
  var MoreMenu = UIKit.Tree.extend({
    attributes: {
      tabindex: 0,
      'aria-haspopup': 'true',
      'aria-expanded': 'false'
    },
    options: {
      model: new Backbone.Model()
    },
    initialize: function initialize() {
      UIKit.Tree.prototype.initialize.apply(this, arguments);
      this.once('render', function (view) {
        var menuItemLink = view.$el.find('.node .title a.text');
        var menuItemHeader = view.$el.find('.content .title span');
        view.$el.find('.node').first().attr({
          'aria-label': view.model.get('text')
        });
        view.$el.find('.content').first().attr({
          role: 'menu'
        });
        view.$el.find('.content .title').attr({
          role: 'menuitem'
        });
        view.$el.find('.content .node.section-divider > .title').attr({
          role: 'divider'
        });
        menuItemLink.each(function (index, item) {
          $(item).attr({
            'aria-label': item.innerHTML + " - menu item"
          });
        });
        menuItemHeader.each(function (index, item) {
          $(item).attr({
            'aria-label': item.innerHTML + " - heading item"
          });
        });
      });
    },
    childView: MoreMenuItem,
    getLeafMenuItems: function getLeafMenuItems() {
      if (!this.leafMenuItems) {
        this.leafMenuItems = this.$el.find('.title:visible').not('.active');
      }
      return this.leafMenuItems;
    },
    getLeafMenuItemIndex: function getLeafMenuItemIndex(menuItem) {
      return this.leafMenuItems.index(menuItem.$el.find('.title:visible'));
    },
    onKeyDown: function onKeyDown(ev, menuItem) {
      var $leafMenuItems = this.getLeafMenuItems();
      var currentIndex = this.getLeafMenuItemIndex(menuItem);
      switch (ev.keyCode) {
        case 13:
        case 32:
          $leafMenuItems.eq(currentIndex).find('a').click();
          break;
        case 27:
          var parentCurrentIndex = this._parent.getMenuItemViewIndex(this);
          this.$el.find('.title:visible').first().click();
          this._parent.getMenuItemViewByIndex(parentCurrentIndex).$el.focus();
          break;
        case 35:
          ev.preventDefault();
          ev.stopImmediatePropagation();
          $leafMenuItems.last().focus();
          break;
        case 36:
          ev.preventDefault();
          ev.stopImmediatePropagation();
          $leafMenuItems.first().focus();
          break;
        case 37:
          var parentCurrentIndex = this._parent.getMenuItemViewIndex(this);
          var itemIndex = parentCurrentIndex > 0 ? parentCurrentIndex - 1 : this._parent.getMenuItemViews().length - 1;
          ev.preventDefault();
          ev.stopImmediatePropagation();
          this.$el.find('.title:visible').first().click();
          this._parent.getMenuItemViewByIndex(itemIndex).$el.focus();
          break;
        case 38:
          var itemIndex = currentIndex > 0 ? currentIndex - 1 : $leafMenuItems.length - 1;
          ev.preventDefault();
          $leafMenuItems.get(itemIndex).focus();
          break;
        case 39:
          var parentCurrentIndex = this._parent.getMenuItemViewIndex(this);
          var itemIndex = parentCurrentIndex > this._parent.getMenuItemViews().length - 1 ? parentCurrentIndex + 1 : 0;
          ev.preventDefault();
          ev.stopImmediatePropagation();
          this.$el.find('.title:visible').first().click();
          this._parent.getMenuItemViewByIndex(itemIndex).$el.focus();
          break;
        case 40:
          var itemIndex = currentIndex < $leafMenuItems.length - 1 ? currentIndex + 1 : 0;
          ev.preventDefault();
          $leafMenuItems.get(itemIndex).focus();
          break;
        default:
          break;
      }
    },
    onAccordionOpen: function onAccordionOpen(rootView) {
      rootView.updateElementAttributes({
        'aria-expanded': 'true'
      });
    },
    onAccordionClose: function onAccordionClose(rootView) {
      rootView.updateElementAttributes({
        'aria-expanded': 'false'
      });
    }
  });
  var ProductNavigationMenu = UIKit.Menu.extend({
    tagName: 'nav',
    className: UIKit.Menu.prototype.className + ' product-header',
    attributes: {
      'aria-labelledby': 'mainNavigationLabel'
    },
    options: _.extend({}, UIKit.Menu.prototype.options, {
      fixed: true,
      size: 'large',
      title: false
    }),
    events: {
      'keydown div[role="menubar"] > .item': 'handleMenuItemKeydown',
      'click div[role="menubar"] > .item': 'handleMenuItemClick',
      'keydown div[role="menubar"] > .item ul': 'handleDropdownMenuKeydown',
      'focusout div[role="menubar"] > .item ul a': 'handleDropdownMenuItemFocusOut',
      'keydown div[role="menubar"] > .item div.title:visible': 'handleMoreDropdownItemKeydown'
    },
    getMenuItemViews: function getMenuItemViews() {
      return _.map(this._views, function (menuItemViewConfig) {
        return menuItemViewConfig.view;
      });
    },
    getMenuItemViewIndex: function getMenuItemViewIndex(menuItemView) {
      return this.getMenuItemViews().indexOf(menuItemView);
    },
    getMenuItemViewByIndex: function getMenuItemViewByIndex(itemIndex) {
      return this.getMenuItemViews()[itemIndex];
    },
    focusDropdownMenuItem: function focusDropdownMenuItem(items, target, index) {
      items.eq(index).focus();
      $(target).attr('aria-activedescendant', items.eq(index).attr('id'));
      items.eq(index).addClass('selected');
    },
    handleMenuItemClick: function handleMenuItemClick(ev) {
      var menuItem = $(ev.target).find('.text').first() || $(ev.target).parent().find('.text').first();
      if (['reporting', 'more'].includes(menuItem.text().trim().toLowerCase())) {
        if (ev.target.className.match('ui') !== null) {
          if (menuItem.text().trim().toLowerCase() === 'more') {
            menuItem[0].click();
            var activeItem = $("div[aria-label='More']").find('.content.active');
            activeItem.focus();
          }
          if (menuItem.text().trim().toLowerCase() === 'reporting') {
            var reportingMenu = $(ev.target).find('.menu').first();
            reportingMenu.hasClass('visible') ? reportingMenu.removeClass('visible') : reportingMenu.addClass('transition visible');
          }
        }
      }
      if ($(ev.target).prop("tagName") === 'A') {
        if ($(ev.target).text() === 'Checklists' || $(ev.target).text() === 'Submissions') {
          window.setTimeout(function () {
            $('#content').find('.btn')[0].focus();
          }, 1000);
        } else {
          window.setTimeout(function () {
            $('#irb-content')[0].focus();
          }, 1000);
        }
      }
    },
    handleMoreDropdownItemKeydown: function handleMoreDropdownItemKeydown(ev) {
      var children = $("div[aria-label='More']").find('div.title:not(.active):visible');
      var currentItem = children.filter(ev.target);
      var currentItemIndex = children.index(currentItem);
      if (ev.keyCode === 40) {
        children.eq(currentItemIndex === children.length - 1 ? 0 : currentItemIndex + 1).focus();
      }
      if (ev.keyCode === 38) {
        children.eq(currentItemIndex === 0 ? children.length - 1 : currentItemIndex - 1).focus();
      }
    },
    handleDropdownMenuItemFocusOut: function handleDropdownMenuItemFocusOut(ev) {
      if (ev.relatedTarget && !['A', 'UL'].includes(ev.relatedTarget && ev.relatedTarget.tagName)) {
        var reportingMenu = $('nav.product-header div[role="menubar"] > .item ul');
        var parentMenu = $(reportingMenu).parent()[0];
        $(parentMenu).removeClass("active visible");
        reportingMenu.removeClass("visible");
        reportingMenu.removeAttr("aria-active-descendant");
        reportingMenu.find('a').removeClass('selected active');
      }
    },
    handleDropdownMenuKeydown: function handleDropdownMenuKeydown(ev) {
      var children = $(ev.currentTarget).find('a');
      var currentItem = children.filter(ev.target);
      var currentItemIndex = children.index(currentItem);
      if (ev.keyCode === 40) {
        children.eq(currentItemIndex).removeClass('selected');
        if (currentItemIndex === children.length - 1) {
          this.focusDropdownMenuItem(children, ev.currentTarget, 0);
        } else {
          this.focusDropdownMenuItem(children, ev.currentTarget, currentItemIndex + 1);
        }
      }
      if (ev.keyCode === 38) {
        children.eq(currentItemIndex).removeClass('selected');
        if (currentItemIndex === 0) {
          this.focusDropdownMenuItem(children, ev.currentTarget, children.length - 1);
        } else {
          this.focusDropdownMenuItem(children, ev.currentTarget, currentItemIndex - 1);
        }
      }
    },
    handleMenuItemKeydown: function handleMenuItemKeydown(ev) {
      var menuItemViews = this.getMenuItemViews();
      var menuItemText = $(ev.target).find('.text').first().text();
      var currentItemView = _.findWhere(menuItemViews, {
        'text': menuItemText.trim()
      });
      var currentIndex;
      var hasSubMenu;
      var subMenuContent;
      var isReportingMenu = menuItemText.toLowerCase().includes('report');
      var isMoreMenu = menuItemText.toLowerCase().includes('more');
      if (isReportingMenu) {
        if (ev.keyCode === 13) {
          $(ev.target).find("ul").attr('role', 'menubar');
          $(ev.target).find("ul a").attr('role', 'menuitem');
          currentItemView.focus();
        }
        if (ev.keyCode === 40) {
          $(ev.target).find('.item').first().focus();
        }
      }
      if (isMoreMenu && ev.keyCode === 13) {
        $("div[aria-label='More']").find("div.title[role='divider']").attr('role', 'menuitem');
      }
      if (!currentItemView) {
        var isReportMenu = $(ev.target).find('.selected').first().text().toLowerCase().includes('report');
        if (isReportMenu) {
          switch (ev.keyCode) {
            case 13:
              $(ev.target).find('.selected')[0].click();
            default:
              break;
          }
        }
        return;
      }
      currentIndex = this.getMenuItemViewIndex(currentItemView);
      hasSubMenu = currentItemView.model.get('children');
      switch (ev.keyCode) {
        case 13:
          if (!hasSubMenu) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
            $(ev.target)[0].click();
          }
        case 32:
        case 40:
          ev.preventDefault();
          ev.stopImmediatePropagation();
          if (hasSubMenu) {
            subMenuContent = currentItemView.$el.find('.content').first();
            currentItemView.$el.find('.title:visible').first().click();
            subMenuContent.find('.title:visible').first().focus();
          }
          break;
        case 35:
          ev.preventDefault();
          this.getMenuItemViewByIndex(menuItemViews.length - 1).$el.focus();
          break;
        case 36:
          ev.preventDefault();
          this.getMenuItemViewByIndex(0).$el.focus();
          break;
        case 37:
          var itemIndex = currentIndex > 0 ? currentIndex - 1 : menuItemViews.length - 1;
          this.getMenuItemViewByIndex(itemIndex).$el.focus();
          break;
        case 38:
          if (hasSubMenu) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
            subMenuContent = currentItemView.$el.find('.content').first();
            currentItemView.$el.find('.title:visible').first().click();
            subMenuContent.find('.title:visible').last().focus();
          }
          break;
        case 39:
          var itemIndex = currentIndex < menuItemViews.length - 1 ? currentIndex + 1 : 0;
          this.getMenuItemViewByIndex(itemIndex).$el.focus();
          break;
        default:
          break;
      }
      return;
    },
    collectionize: function collectionize(items) {
      items = _.clone(items);
      for (var i = 0, len = items.length, item; i < len; i++) {
        item = _.clone(items[i]);
        if (item && item.children) {
          item.children = this.collectionize(item.children);
        }
        items[i] = item;
      }
      return new Backbone.Collection(items);
    },
    setupProductMoreMenu: function setupProductMoreMenu(data) {
      var view = new MoreMenu();
      var defaultBindings = {
        collection: 'children',
        text: 'text',
        link: 'link',
        target: 'target',
        icon: 'icon',
        iconRight: 'iconRight',
        inverted: 'inverted',
        pointing: 'pointing',
        sectionDivider: 'sectionDivider'
      };
      view.model.set(data);
      view.model.set('children', this.collectionize([data]));
      view.bindings = view.childBindings = _.clone(defaultBindings);
      return view;
    },
    createNavigationItems: function createNavigationItems() {
      var navList = Radio.channel('global').request('navigationList');
      var navigationItems = UIKit.Menu.createMenuItems(navList);
      var moreMenuData = _.findWhere(navList, {
        name: 'more'
      });
      var reportingData = _.findWhere(navList, {
        'data-name': 'reporting'
      });
      var meetingsData = _.findWhere(navList, {
        'data-name': 'meetings'
      });
      var tasksData = _.findWhere(navList, {
        'data-name': 'tasks'
      });
      var moreMenuIndex = navList.indexOf(moreMenuData);
      var reportingIndex = navList.indexOf(reportingData);
      var meetingsIndex = navList.indexOf(meetingsData);
      var tasksIndex = navList.indexOf(tasksData);
      var reportingItem = navigationItems[reportingIndex];
      var meetingsItem = navigationItems[meetingsIndex];
      var tasksItem = navigationItems[tasksIndex];
      if (reportingItem && !$(reportingItem.el).hasClass('reporting-menu-item')) {
        $(reportingItem.el).addClass('reporting-menu-item');
      }
      navigationItems[moreMenuIndex] = this.setupProductMoreMenu(moreMenuData);
      setTimeout(function () {
        if (meetingsItem && !$(meetingsItem.el).hasClass('meetings-menu-item')) {
          $(meetingsItem.el).addClass('meetings-menu-item');
        }
        if (tasksItem && !$(tasksItem.el).hasClass('tasks-menu-item')) {
          $(tasksItem.el).addClass('tasks-menu-item');
        }
      }, 300);
      return navigationItems;
    },
    addNavigationItemsToProductMenu: function addNavigationItemsToProductMenu(navigationItems) {
      var menuHeader = $('<h2>', {
        id: 'mainNavigationLabel',
        "class": 'accessibility-text',
        text: 'Site Menu'
      });
      var productMenu = this;
      this.addAll(navigationItems);
      _.defer(function () {
        productMenu.$el.prepend(menuHeader);
      });
      this.listenTo(Backbone.history, 'route', function (router, name) {
        _.each(navigationItems, _.partial(this.updateNavigationItemOnRoute, name), this);
      });
    },
    updateNavigationItemOnRoute: function updateNavigationItemOnRoute(name, item) {
      if (item.model.get('name') === name) {
        if (item._parent) {
          item._parent.active = true;
        }
        item.active = true;
      } else {
        item.active = false;
      }
      item.value = null;
      if (item.each) {
        item.each(_.partial(this.updateNavigationItemOnRoute, name), this);
      } else if (item.children) {
        item.children.each(_.partial(this.updateNavigationItemOnRoute, name), this);
      }
    },
    setupProductMenu: function setupProductMenu() {
      var navigationItems = this.createNavigationItems();
      this.addNavigationItemsToProductMenu(navigationItems);
      $(document).click(function (event) {
        var target = $(event.target);
        if (!target.closest('.product-header .accordion > .node > .content.active').length && $('.product-header .accordion > .node > .content.active').is(":visible")) {
          $('.product-header .accordion > .node > .content').hide();
          $('.product-header .accordion > .node > .title').removeClass('active');
        }
      });
      this.on('childview:change:selected', function (parent, child, model) {
        parent.selected = null;
        if (model && model.has('command')) {
          this.app.execute(model.get('command'));
        }
      }, this);
    }
  });
  module.exports = ProductNavigationMenu;
});

